import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-tertiary-accordian.component.html',
  styleUrls: ['./commodity-tertiary-accordian.component.css']
})
export class  CommodityTertiaryAccordianComponent extends AbstractFormWidgetComponent {

  public accordionLine1: Array<any> = ['cyclecountFrequency', 'lastCycleCount', 'reorderPoint'];
  public accordionLine2: Array<any> = ['reorderQty', 'stdorderCost', 'carryCost', 'price', 'cost'];
  public accordionLine3: Array<any> = ['abcpl', 'abccs', 'abcPeriod', 'abcea', 'disableabccalc'];
  public accordionLine4: Array<any> = ['abcstorerKey', 'abcSku', 'oldstorerKey', 'oldSku'];

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
    }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/commodity-tertiary-accordian/commodity-tertiary-accordian.component.ts